import { theme } from "../theme.ts";

/**
 * Controlled text search box. Same visual treatment as the Demand-page SKU
 * input (bordered, brand-color focus ring). Used to filter the Monitor and
 * Forecast tables by SKU id.
 */
export function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  ariaLabel,
  width = 240,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  width?: number;
}) {
  return (
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel ?? placeholder}
      style={{
        padding: `${theme.space.sm}px ${theme.space.md}px`,
        border: `1px solid ${theme.color.border}`,
        borderRadius: theme.radius.md,
        fontSize: theme.font.size.md,
        width,
        maxWidth: "100%",
        outline: "none",
        transition: "border-color 100ms ease",
      }}
      onFocus={(e) => (e.currentTarget.style.borderColor = theme.color.brand)}
      onBlur={(e) => (e.currentTarget.style.borderColor = theme.color.border)}
    />
  );
}
